<template>
  <div class="app-container member-detail">
    <basic-container v-loading="loading">
      <el-tabs v-model="activeName" @tab-click="onTabShow">
        <el-tab-pane label="基本资料" name="detail">
          <el-row class="member-detail-item">
            <el-col :span="4" class="head">ID:</el-col>
            <el-col :span="16">{{memberDetail.memberId}}</el-col>
          </el-row>
          <div class="operation" v-if="permissions.member_edit && isEdit">
            <el-button @click="cancelEdit">取消</el-button>
            <el-button type="primary" @click="save">保存</el-button>
          </div>
          <el-row class="member-detail-item">
            <el-col :span="4">头像:</el-col>
            <el-col :span="16">
              <img class="avatar-right" :src="memberDetail.avatar" />
            </el-col>
          </el-row>
          <el-row class="member-detail-item">
            <el-col :span="4">Full Name:</el-col>
            <el-col :span="16">{{memberDetail.nickname}}</el-col>
          </el-row>
          <el-row class="member-detail-item">
            <el-col :span="4">Birth Name:</el-col>
            <el-col :span="16">{{memberDetail.realname}}</el-col>
          </el-row>
          <!-- <el-row class="member-detail-item" v-if="!isEdit">
            <el-col :span="4">性别:</el-col>
            <el-col :span="16">{{memberDetail.gender}}</el-col>
          </el-row> -->
          <el-row class="member-detail-item">
            <el-col :span="4">手机号:</el-col>
            <el-col :span="16" v-if="!isEdit">
              <sensitive-data type="phoneNumber" :rawData="memberDetail.phoneNumber" :unionId="memberDetail.unionId" />
            </el-col>
            <el-col :span="8" v-else>
              <el-input v-model="updateForm.phoneNumber" placeholder="请输入手机号" size="medium" maxlength="11"></el-input>
            </el-col>
          </el-row>
          <!-- <el-row class="member-detail-item" v-if="isEdit">
            <el-col :span="3">证件类型</el-col>
            <el-col :span="8">
              <el-select placeholder="选择证件类型" v-model="updateForm.certificateType" size="medium" clearable>
                <el-option
                  v-for="item in certificateType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row class="member-detail-item" v-if="isEdit">
            <el-col :span="3">证件号:</el-col>
            <el-col :span="8">
              <el-input v-model="updateForm.certificateNumber" placeholder="请输入证件号" size="medium" maxlength="18"></el-input>
            </el-col>
          </el-row> -->
          <el-row class="member-detail-item" v-if="!isEdit">
            <el-col :span="4">员工号:</el-col>
            <el-col :span="16">{{memberDetail.unionId}}</el-col>
          </el-row>
          <!-- <el-row class="member-detail-item" v-if="!isEdit">
            <el-col :span="4">所属市场:</el-col>
            <el-col :span="16">{{memberDetail.marketName}}</el-col>
          </el-row> -->
          <!-- <el-row class="member-detail-item" v-if="!isEdit">
            <el-col :span="4">Email:</el-col>
            <el-col :span="16">{{memberDetail.email}}</el-col>
          </el-row> -->
          <!-- <el-row class="member-detail-item" v-if="!isEdit">
            <el-col :span="4">公司名称:</el-col>
            <el-col :span="16">{{memberDetail.company}}</el-col>
          </el-row> -->
          <el-row class="member-detail-item" v-if="!isEdit">
            <el-col :span="4">Position Name:</el-col>
            <el-col :span="16">{{memberDetail.position}}</el-col>
          </el-row>
          <el-row class="member-detail-item" v-if="!isEdit">
            <el-col :span="4">Organizational Unit Name:</el-col>
            <el-col :span="16">{{memberDetail.organizationalUnitName}}</el-col>
          </el-row>
          <el-row class="member-detail-item" v-if="!isEdit">
            <el-col :span="4">Leader:</el-col>
            <el-col :span="16">{{memberDetail.leader}}</el-col>
          </el-row>
          <el-row class="member-detail-item" v-if="!isEdit">
            <el-col :span="4">Staffing Model:</el-col>
            <el-col :span="16">{{memberDetail.staffingModel}}</el-col>
          </el-row>
          <!-- <el-row class="member-detail-item" v-if="!isEdit">
            <el-col :span="4">地区:</el-col>
            <el-col :span="16">{{memberDetail.location}}</el-col>
          </el-row> -->
          <el-row class="member-detail-item" v-if="!isEdit">
            <el-col :span="4">用户标签:</el-col>
            <el-col :span="16">{{memberDetail.organizationTag}}</el-col>
          </el-row>
          <!-- <el-row class="member-detail-item" v-if="!isEdit">
            <el-col :span="4">已加入的圈子:</el-col>
            <el-col :span="16">{{memberDetail.joinedCircles}}</el-col>
          </el-row> -->
          <!--
          <el-row class="member-detail-item">
            <el-col :span="4">帖子总数:</el-col>
            <el-col :span="16">
              {{ memberDetail.postCount }}
              <a href="javascript:void(0);" @click="toPostList"
                class="member-detail-item-button">
                {{ memberDetail.postCount }}</a>
            </el-col>
          </el-row>
          -->
          <!-- <el-row class="member-detail-item" v-if="!isEdit">
            <el-col :span="4">广场帖子数:</el-col>
            <el-col :span="16">{{memberDetail.globalPostCount}}</el-col>
          </el-row>
          <el-row class="member-detail-item" v-if="!isEdit">
            <el-col :span="4">总积分:</el-col>
            <el-col :span="3">{{memberDetail.totalReward}}</el-col>
            <el-button v-if="reward_add_btn" size="mini" type="primary" @click="handleInsertReward">添加</el-button>
            <el-button v-if="reward_reduce_btn" size="mini" type="danger" @click="handleReduceReward">减少</el-button>
            <el-button v-if="reward_info_btn" size="mini" type="info" @click="handleInfoReward">积分记录</el-button>
          </el-row> -->
          <!--
          <el-row class="member-detail-item">
            <el-col :span="4">圈子帖子数:</el-col>
            <el-col :span="16">{{memberDetail.circlePostCount}}</el-col>
          </el-row>
          <el-row class="member-detail-item">
            <el-col :span="4">圈子数:</el-col>
            <el-col :span="16">{{memberDetail.circleJoinedCount}}</el-col>
          </el-row>
          -->
          <el-row class="member-detail-item" v-if="!isEdit">
            <el-col :span="4">评论数:</el-col>
            <el-col :span="16">{{ memberDetail.commentCount }}</el-col>
          </el-row>
          <el-row class="member-detail-item" v-if="!isEdit">
            <el-col :span="4">点赞量:</el-col>
            <el-col :span="16">{{memberDetail.likeCount}}</el-col>
          </el-row>
          <!-- <el-row class="member-detail-item" v-if="!isEdit">
            <el-col :span="4">获赞量:</el-col>
            <el-col :span="16">{{memberDetail.achievedLikeCount}}</el-col>
          </el-row> -->
          <el-row class="member-detail-item" v-if="!isEdit">
            <el-col :span="4">收藏量:</el-col>
            <el-col :span="16">{{memberDetail.favoriteCount}}</el-col>
          </el-row>
          <!-- <el-row class="member-detail-item" v-if="!isEdit">
            <el-col :span="4">被收藏量:</el-col>
            <el-col :span="16">{{memberDetail.achievedFavoriteCount}}</el-col>
          </el-row> -->
          <!-- <el-row class="member-detail-item" v-if="!isEdit">
            <el-col :span="4">已关注:</el-col>
            <el-col :span="16">{{memberDetail.followCount}}</el-col>
          </el-row>
          <el-row class="member-detail-item" v-if="!isEdit">
            <el-col :span="4">粉丝:</el-col>
            <el-col :span="16">{{memberDetail.fansCount}}</el-col>
          </el-row> -->
          <el-row class="member-detail-item" v-if="!isEdit">
            <el-col :span="4">在职/离职:</el-col>
            <el-col :span="16">{{memberDetail.isActive}}</el-col>
          </el-row>
          <!-- <el-row class="member-detail-item" v-if="!isEdit">
            <el-col :span="4">账号等级:</el-col>
            <el-col :span="3" v-show="!isEditAccountTier">{{memberDetail.personalTierName}}</el-col>
            <el-col :span="5" v-show="isEditAccountTier">
              <el-select placeholder="选择账号等级" v-model="selectedTierId" size="small" clearable>
                <el-option
                  v-for="item in accountTierOptions"
                  :key="item.tierId"
                  :label="item.personalName"
                  :value="item.tierId">
                </el-option>
              </el-select>
            </el-col>
            <el-button size="mini" type="primary" @click="editAccountTier" v-show="!isEditAccountTier">编辑</el-button>
            <el-button size="mini" type="primary" @click="handleEditAccountTier" v-show="isEditAccountTier">保存</el-button>
            <el-button size="mini" @click="cancelEditTier" v-show="isEditAccountTier">取消</el-button>
          </el-row> -->
          <el-row class="member-detail-item" v-if="!isEdit">
            <el-col :span="4">禁言状态:</el-col>
            <el-col :span="16">{{memberDetail.isBanned}}</el-col>
          </el-row>
          <!-- <el-row class="member-detail-item" v-if="!isEdit">
            <el-col :span="4">账号状态说明:</el-col>
            <el-col :span="16">{{memberDetail.description}}</el-col>
          </el-row> -->
          <el-row class="member-detail-item" v-if="!isEdit">
            <el-col :span="4">注册时间：</el-col>
            <el-col :span="16">{{memberDetail.registerTime}}</el-col>
          </el-row>
        </el-tab-pane>
        <!-- <el-tab-pane label="勋章列表" name="medal" class="medal-list">
          <el-table :data="memberMedalRecordData" stripe tooltip-effect="dark" class="medal-table">
            <el-table-column label="勋章预览" min-width="250">
              <template slot-scope="scope">
                <div class="medal-preview">
                  <div class="lit-image" v-if="scope.row.medalInfo.litUrl" v-viewer>
                    <img :src="scope.row.medalInfo.litUrl">
                  </div>
                  <a href="javascript:void(0);" @click="toMedalDetail(scope.row.medalId);" class="medal-table-href">
                     {{scope.row.medalInfo.gradeName || scope.row.medalInfo.name}}
                  </a>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="勋章状态" width="250">
              <template slot-scope="scope">
                {{scope.row.medalInfo.isActive ? "正常" : "已禁用"}}
              </template>
            </el-table-column>
            <el-table-column align="center" label="勋章发放人" width="250">
              <template slot-scope="scope">
                {{scope.row.issuerName || "system"}}
              </template>
            </el-table-column>
            <el-table-column align="center" prop="insertedTime" label="勋章发放时间" width="350"></el-table-column>
          </el-table>
          <el-pagination :page-size="medalPage.pageSize"
                         :page-sizes="medalPage.pageSizes"
                         :current-page="medalPage.currentPage"
                         :total="medalPage.total"
                         :layout="medalPage.layout"
                         @current-change="medalCurrentChange"
                         @size-change="medalSizeChange">
          </el-pagination>
        </el-tab-pane> -->
      </el-tabs>

    </basic-container>
    <el-dialog
      title="添加积分"
      :visible.sync="insertRewardDialog"
      @close="closeDialogHandleInsertReward"
      width="40%"
      class="handle-dialog">
        <el-form ref="insertRewardFrom" :model="insertRewardFrom" :rules="rules">
            <el-form-item prop="rewardValue">
              <el-label >积分值:</el-label>
                <el-input type="number" placeholder="请输入积分值" v-model="insertRewardFrom.rewardValue"></el-input>
            </el-form-item>
            <el-form-item prop="comment">
              <el-label >添加原因:</el-label>
                <el-input type="text" placeholder="请输入备注" v-model="insertRewardFrom.comment"></el-input>
            </el-form-item>
            <div class="handle-dialog-footer">
              <el-button type="primary" class="handle-dialog-footer-save" @click="insertReward">确定</el-button>
              <el-button class="handle-dialog-footer-cancel" @click="insertRewardDialog = false">取消</el-button>
            </div>
        </el-form>
    </el-dialog>
    <el-dialog
      title="减少积分"
      :visible.sync="reduceRewardDialog"
      @close="closeDialogHandleReduceReward"
      width="40%"
      class="handle-dialog">
        <el-form ref="reduceRewardFrom" :model="reduceRewardFrom" :rules="rules">
            <el-form-item prop="rewardValue">
              <el-label >积分值:</el-label>
                <el-input type="number" placeholder="请输入积分值" v-model="reduceRewardFrom.rewardValue"></el-input>
            </el-form-item>
            <el-form-item prop="comment">
              <el-label >减少原因:</el-label>
                <el-input type="text" placeholder="请输入备注" v-model="reduceRewardFrom.comment"></el-input>
            </el-form-item>
            <div class="handle-dialog-footer">
              <el-button type="primary" class="handle-dialog-footer-save" @click="reduceReward">确定</el-button>
              <el-button class="handle-dialog-footer-cancel" @click="reduceRewardDialog = false">取消</el-button>
            </div>
        </el-form>
    </el-dialog>
    <el-dialog
      title="积分记录"
      :visible.sync="rewardInfoDialog"
      width="60%"
      class="handle-dialog">
      <div>
        <div>当前总积分：{{this.memberDetail.totalReward}}</div>
        <avue-crud :option="option"
                  :data="recordList"
                  ref="crud"
                  v-model="recordForm"
                  :page="page"
                  :table-loading="listLoading"
                  :before-open="handleOpenBefore"
                  @current-change="handleCurrentChange"
                  @size-change="handleSizeChange">
        </avue-crud>
      </div>
      <div class="handle-dialog-footer">
        <el-button class="handle-dialog-footer-cancel" @click="rewardInfoDialog = false;">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { getObj, putObj, getTag, putTag, fetchMemberInviteeList, updateMemberTierByMemberId, updateMember} from '@/api/admin/member'
  import { adminEditReward, getRewardRecordList} from '@/api/reward/record'
  import { getAllTagsAdmin, getAllTagTypesAdmin } from '@/api/basic/tagtype'
  import { getMemberMedalRecordPage } from '@/api/medal/medal'
  import { rewardDetail } from '@/const/crud/reward/record';
  import { getCertificateType } from '@/const/crud/admin/member';
  import anonymousImage from '@/static/images/member/anonymous.svg';
  import { mapGetters } from 'vuex'
  import { fetchAccountTierList } from '@/api/admin/tier'
  import SensitiveData from '@/components/sensitive-data';

  const initDetail = vm => {
    getObj(vm.id).then(response => {
      let data = response.data
        if (response.status == 200) {
          vm.memberDetail.tierId = data.data.tierId
          if (vm.isEdit) {
            vm.updateForm.realname = data.data.realname
            vm.updateForm.phoneNumber = data.data.phoneNumber
            vm.updateForm.certificateType = data.data.certificateType
            vm.updateForm.certificateNumber = data.data.certificateNumber
          }
          if (!data.data.phoneNumber) {
            vm.isShowPhoneIcon = false;
          }
          formatMemberDetail(vm.memberDetail, data.data)
        } else {
          vm.$message({
            showClose: true,
            message: '无法查看该员工详情',
            type: 'error'
          })
        }
    }).catch(error => {
      vm.$message({
        message: '获取员工详情失败',
        type: 'error'
      })
    })
    // vm.handleUpdate(vm.memberDetail)
  }

  const formatMemberDetail = (vm, data) => {
    vm.memberId = data.memberId;
    vm.personalTierName = data.personalTierName;

    if (!data.avatar) vm.avatar = anonymousImage;
    else vm.avatar = data.avatar;

    if (!data.nickname) vm.nickname = "--";
    else vm.nickname = data.nickname;

    if (!data.realname) vm.realname = "--";
    else vm.realname = data.realname;

    if (!data.unionId) vm.unionId = "--";
    else vm.unionId = data.unionId;

    if (!data.phoneNumber) vm.phoneNumber = "--";
    else vm.phoneNumber = data.phoneNumber;

    if (!data.marketName) vm.marketName = "--";
    else vm.marketName = data.marketName;

    if (!data.email) vm.email = "--";
    else vm.email = data.email;

    if (data.gender == null) vm.gender = "--";
    else if (data.gender == "MALE") vm.gender = "男";
    else vm.gender = "女";

    if (!data.company) vm.company = "--";
    else vm.company = data.company;

    if (!data.position) vm.position = "--";
    else vm.position = data.position;

    if (!data.grade) vm.grade = "--";
    else vm.grade = data.grade.substring(data.grade.indexOf(' '));

    if (!data.department) vm.department = "--";
    else vm.department = data.department.substring(data.department.indexOf(' '));

    if (!data.organizationalUnitName) vm.organizationalUnitName = "--";
    else vm.organizationalUnitName = data.organizationalUnitName;

    if (!data.leader) vm.leader = "--";
    else vm.leader = data.leader;

    if (!data.staffingModel) vm.staffingModel = "--";
    else vm.staffingModel = data.staffingModel;

    if (!data.locationId) vm.locationId = "--";
    else vm.locationId = data.locationId;
    if (!data.location) vm.location = "--";
    else vm.location = data.location;

    if (!data.organizationTag) vm.organizationTag = "--";
    else vm.organizationTag = data.organizationTag;

    if (!data.joinedCircles) vm.joinedCircles = "--";
    else vm.joinedCircles = data.joinedCircles;

    if (!data.postCount || data.postCount == 0) vm.postCount = 0;
    else vm.postCount = data.postCount;

    if (!data.totalReward || data.totalReward == 0) vm.totalReward = 0;
    else vm.totalReward = data.totalReward;

    if (!data.globalPostCount || data.globalPostCount == 0) vm.globalPostCount = 0;
    else vm.globalPostCount = data.globalPostCount;

    if (!data.circlePostCount || data.circlePostCount == 0) vm.circlePostCount = 0;
    else vm.circlePostCount = data.circlePostCount;

    if (!data.circleJoinedCount || data.circleJoinedCount == 0) vm.circleJoinedCount = 0;
    else vm.circleJoinedCount = data.circleJoinedCount;

    if (!data.commentCount || data.commentCount == 0) vm.commentCount = 0;
    else vm.commentCount = data.commentCount;

    if (!data.likeCount || data.likeCount == 0) vm.likeCount = 0;
    else vm.likeCount = data.likeCount;

    if (!data.achievedLikeCount || data.achievedLikeCount == 0) vm.achievedLikeCount = 0;
    else vm.achievedLikeCount = data.achievedLikeCount;

    if (!data.favoriteCount || data.favoriteCount == 0) vm.favoriteCount = 0;
    else vm.favoriteCount = data.favoriteCount;

    if (!data.achievedFavoriteCount || data.achievedFavoriteCount == 0) vm.achievedFavoriteCount = 0;
    else vm.achievedFavoriteCount = data.achievedFavoriteCount;

    if (!data.followCount || data.followCount == 0) vm.followCount = 0;
    else vm.followCount = data.followCount;

    if (!data.fansCount || data.fansCount == 0) vm.fansCount = 0;
    else vm.fansCount = data.fansCount;

    if (!data.interestTags || data.interestTags.length == 0) {
      vm.interestTags = "--";
    } else {
      vm.interestTags = "";
      data.interestTags.forEach(function(tag, index) {
        if (index == 0) {
          vm.interestTags += tag.tagName;
        } else {
          vm.interestTags += '，' + tag.tagName;
        }
      })
    }


    if (!data.description) vm.description = "--";
    else vm.description = data.description;

    if (data.memberType == null) vm.memberType = "--";
    else if (data.memberType == "PERSONAL") vm.memberType = "个人";
    else if (data.memberType == "ENTERPRISE") vm.memberType = "企业";

    if (data.isBanned != null){
      if (data.isBanned == 0) vm.isBanned = "未禁言";
      else vm.isBanned = "已禁言";
    } else {
      vm.isBanned = "--";
    }
    if (data.isActive != null){
      if (data.isActive == 0) vm.isActive = "离职";
      else vm.isActive = "在职";
    } else {
      vm.isActive = "--";
    }
    if (!data.registerTime) vm.registerTime = "--";
    else vm.registerTime = data.registerTime;
  }

  export default {
    components: {
      SensitiveData,
    },
    data () {
      return {
        isEdit: false,
        // 基本资料详情窗口
        activeName: "detail",
        loading: false,
        recordList: [],
        recordForm: {},
        listLoading: false,
        search: {
          current: 1,
          size: 10
        },
        page: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 10, // 每页显示多少条,
        },
        insertRewardFrom: {
          memberId: undefined,
          rewardValue: 0,
          comment: ""
        },
        reduceRewardFrom: {
          memberId: undefined,
          rewardValue: 0,
          comment: ""
        },
        memberDetail: {
          memberId: undefined,
          avatar: "",
          nickname: "",
          realname: "",
          phoneNumber: "",
          totalReward: "",
          email: "",
          locationId: undefined,
          location: "",
          organizationTag: "",
          gender: undefined,
          company: "",
          position: "",
          organizationalUnitName: "",
          leader: "",
          interestTags: "", //会员自感兴趣的品种标签
          description: "",
          memberType: 0,
          isBanned: 0,
          isActive: 0,
          registerTime: "",
          postCount : 0,
          globalPostCount: 0,
          circlePostCount: 0,
          circleJoinedCount: 0,
          commentCount: 0,
          likeCount: 0,
          achievedLikeCount: 0,
          favoriteCount: 0,
          achievedFavoriteCount: 0,
          followCount: 0,
          fansCount: 0,
          memberTags: [], //管理员给予会员的标签
          memberTagNames: "",
          unionId: "",
          marketName: "",
          tierId: null,
          personalTierName: ""
        },

        // 编辑窗口 TODO
        dialogEditVisible: false,
        insertRewardDialog: false,
        reduceRewardDialog: false,
        rewardInfoDialog: false,
        reward_reduce_btn: false,
        reward_add_btn: false,
        reward_info_btn: false,
        option: rewardDetail,
        tagOptions: [],
        editTagOptions: [],
        tagTypeOptions: [], // 标签类型, 新建标签时会显示
        newTagId: '', // 新建标签ID
        newTagName: '', // 新建标签名称
        newTagType: '', // 新建标签类型
        editForm: {
          tagIds:[]
        },
        rules: {
            rewardValue: [
              {
                required: true,
                message: '积分值不能为空',
                trigger: 'blur'
              },{
                pattern: /^\+?[1-9][0-9]*$/,
                message: '请输入九位以内的正整数',
                trigger: 'blur'
              }
            ],
            comment: [
              {
                required: true,
                message: '备注不能为空',
                trigger: 'blur'
              }
            ]
        },
        // 账号等级相关数据
        isEditAccountTier: false,
        accountTierOptions: [],
        selectedTierId: null,
        // 编辑 真实姓名、手机号、证件类型、证件号等
        certificateType: getCertificateType(),
        updateForm: {
          realname: '',
          phoneNumber: '',
          certificateType: 1,
          certificateNumber: '',
        },
        // 用户勋章相关数据
        memberMedalRecordData: [],
        medalPage: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
          pageSizes: [10, 20, 30, 40, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper"
        },
        isShowPhoneIcon: true,
      }
    },
    watch: {
      $route () {
        this.id = this.$route.params.id
        initDetail(this)
      }
    },
    created() {
      this.initPage()
      this.reward_add_btn = this.permissions['member_reward_add']
      this.reward_reduce_btn = this.permissions['member_reward_reduce']
      this.reward_info_btn = this.permissions['member_reward_info']
    },
    mounted () {
      this.isEdit = this.$route.path.includes('edit')
      this.id = this.$route.params.id
      initDetail(this)
    },
    computed: {
      ...mapGetters(['permissions'])
    },
    methods: {
      cancelEdit() {
        this.$router.$avueRouter.closeTag()
        this.$router.go(-1)
      },
      save() {
        const data = {}

        data.id = this.id
        const form = this.updateForm
        data.realname = form.realname;
        data.phoneNumber = form.phoneNumber
        data.accountMemberCertificateType = form.certificateType
        data.certificateNumber = form.certificateNumber

        updateMember(data).then(({ data }) => {
          if (data.code === 0) {
            this.$message.success('编辑成功')
            this.$router.push('/member/member')
          }
        });
      },
      toPostList() {
        // 会员详情里点击帖子数，链接转到会员创建的帖子列表
        this.$router.push({
          path: "/post/posts",
          query: {
            memberId: this.id
          }
        })
      },
      toCommentList() {
        // 会员详情里点击评论数，链接转到会员创建的评论列表
        this.$router.push({
          path: "/post/comment",
          query: {
            memberId: this.id
          }
        })
      },
      getList() {
        let params = {
          current: this.search.current,
          size: this.search.size
        }
        this.listLoading = true
        getRewardRecordList(params,this.memberDetail.memberId).then(response => {
          var records = response.data.data
          if (records.records && records.records.length > 0) {
            records.records.forEach(function(record) {
              var comment = record.comment
              var entityId = record.entityId
              if (!comment) {
                record.comment = "--"
              }
              if (!entityId) {
                record.entityId = "--"
              }
            })
          }
          this.recordList = records.records
          this.page.total = records.total
          this.listLoading = false
        })
      },
      initPage() {
        this.page.currentPage = 1
        this.page.pageSize = this.search.size
        this.search.current = 1
      },
      // 页码发生变化
      handleCurrentChange(val) {
        this.page.currentPage = val
        this.search.current = val
        this.getList()
      },
      // 页面展示数据条数发生变化
      handleSizeChange(val) {
        this.page.pageSize = val
        this.page.currentPage = 1
        this.search.size = val
        this.search.current = 1
        this.getList()
      },
      handleUpdate(row) {
        let _this = this
        this.editForm.tagIds = []
        row.memberTagNames = ""
        getTag(this.id).then(response => {
          let data = response.data
          if (response.status == 200) {
            let ls = data.data
            row.memberTags = []
            _this.editTagOptions = []
            ls.forEach(function(memberTag, index) {
              row.memberTags.push(memberTag.tagId)
              _this.editTagOptions.push({
                label: memberTag.tagName,
                value: memberTag.tagId
              })
              if (index == 0) row.memberTagNames += memberTag.tagName;
              else row.memberTagNames += '，' + memberTag.tagName;
            })
            if(!row.memberTagNames || row.memberTagNames.length == 0) {
              row.memberTagNames = "--";
            }
            if (row.memberTags && row.memberTags.length > 0) {
              row.memberTags.forEach(function(memberTag, index) {
                _this.editForm.tagIds.push(memberTag)
              })
            }
          } else {
            _this.$message({
              showClose: true,
              message: '无法查看该员工的管理员标签',
              type: 'error'
            })
          }
        }).catch(function () {
        })
      },
      handleOpenBefore(show, type) {
        show();
      },
      handleInsertReward() {
        this.insertRewardDialog = true
        this.insertRewardFrom.memberId = this.memberDetail.memberId
      },
      handleReduceReward() {
        this.reduceRewardDialog = true
        this.reduceRewardFrom.memberId = this.memberDetail.memberId
      },
      handleInfoReward() {
        this.rewardInfoDialog = true
        this.getList()
      },
      closeDialogHandleInsertReward() {
        this.$refs.insertRewardFrom.resetFields();
      },
      closeDialogHandleReduceReward() {
        this.$refs.reduceRewardFrom.resetFields();
      },
      insertReward() {
        var _this = this
        _this.$refs.insertRewardFrom.validate((valid) => {
            if (!valid) return
            var insertRewardFrom = _this.insertRewardFrom
            adminEditReward(insertRewardFrom).then(() => {
              this.insertRewardDialog = false;
              initDetail(this)
              _this.$notify({
                  title: '成功',
                  message: '添加成功',
                  type: 'success',
                  duration: 2000
              })
            })
        .catch(function () {});
        })
      },
      reduceReward() {
        var _this = this
        _this.$refs.reduceRewardFrom.validate((valid) => {
            if (!valid) return
            _this.reduceRewardFrom.rewardValue = -_this.reduceRewardFrom.rewardValue
            var reduceRewardFrom = _this.reduceRewardFrom
            adminEditReward(reduceRewardFrom).then(() => {
              this.reduceRewardDialog = false;
              initDetail(this)
                _this.$notify({
                  title: '成功',
                  message: '减少成功',
                  type: 'success',
                  duration: 2000
              })
            })
        .catch(function () {});
        })
      },
      editAccountTier() {
        this.loadAccountTierOptions();
        this.selectedTierId = this.memberDetail.tierId // 回显
        this.isEditAccountTier = true;
      },
      cancelEditTier() {
        this.isEditAccountTier = false;
        this.selectedTierId = this.memberDetail.tierId;
      },
      handleEditAccountTier() {
        if (!this.selectedTierId) {
          this.$message({
            message: '账号等级不能为空',
            type: 'error'
          })
          return false;
        }
        updateMemberTierByMemberId(this.memberDetail.memberId, this.selectedTierId).then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: '编辑成功',
              type: 'success'
            })
            initDetail(this);
            this.isEditAccountTier = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            })
          }
        }).catch(err => {
          this.$message({
            message: err,
            type: 'error'
          })
        })
      },
      loadAccountTierOptions() {
        fetchAccountTierList().then(response => {
          this.accountTierOptions = response.data.data;
        });
      },
      onTabShow(tab) {
        switch (tab.name) {
          case 'medal':
            this.getMemberMedalRecordList();
            break;
        }
      },
      getMemberMedalRecordList() {
        let params = {
          current: this.medalPage.currentPage,
          size: this.medalPage.pageSize,
          memberId: this.id
        }        
        getMemberMedalRecordPage(params).then(response => {
          if (response.data.data != null) {
            this.memberMedalRecordData = response.data.data.records;
            // this.memberMedalRecordData.forEach(item => {
            //   item.issuerName = item.issuerName || 'system';
            // });
            this.medalPage.total = response.data.data.total;
          } else  {
            this.memberMedalRecordData = null;
            this.medalPage.total = 0;
          }
        }).catch(error => {
          this.$message({
            showClose: true,
            message: '获取用户的勋章列表失败',
            type: 'error'
          })
        })
      },
      toMedalDetail(medalId) {
        this.$router.push({
          path: `/reward/medal/detail/${medalId}`
        })
      },
      medalCurrentChange(val) {
        this.medalPage.currentPage = val;
        this.getMemberMedalRecordList();
      },
      medalSizeChange(val) {
        this.medalPage.pageSize = val;
        this.getMemberMedalRecordList();
      },
    }
  }

</script>

<style lang="scss" scoped>
.member-detail {
  .member-detail-item {
    font-size: 16px;
    margin: 10px 0;
    &-button {
      margin: 0 0;
      margin-top: -8px;
      color: #409EFF;
      font-size: 15px;
      text-align: center;
      font-weight: 500;
    }
    &-editButton {
      margin-left: 10px;
    }
  }
  .avatar-right {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    vertical-align: top;
    object-fit: cover;
  }
  .member-detail-edit {
    margin-top: 40px;
    &-button {
      position: absolute;
      right: 0px;
      top: 13px;
      padding: 8px 12px;
    }
  }
  &-tagForm {
    width: 550px;
  }
  &-save {
    padding: 8px 12px;
  }
  &-cancel {
    padding: 8px 12px;
  }
}
/deep/ .avue-crud__menu {
      display: none;
}
.operation {
  text-align: right
}
.handle-dialog {
  display: flex;
  flex-direction: column;
    &-footer{
      display: flex;
      flex-direction: row;
      padding: 50px 0px;
      &-save {
        padding: 8px 12px;
        position: absolute;
        right: 90px;
      }
      &-cancel {
        padding: 8px 12px;
        position: absolute;
        right: 10px;
        margin-right: 10px;
      }
    }
  }
.medal-list {
  .medal-table {
    .medal-preview {
      display: flex;
      align-items: center;
      .lit-image {
        display: flex;
        width: fit-content;
        margin-right: 12px;
        cursor: pointer;
        img {
          width: 40px;
          height: 40px;
          object-fit: cover;
          max-width: 100%;
        }
      }
    }
    &-href {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 170px;
      text-align: left;
    }
  }
  .el-pagination {
    margin-top: 10px;
  }
}
</style>
